import "./course_card.css";
import Button from "antd/lib/button";
import Rate from "antd/lib/rate";
import { useNavigate } from "react-router-dom";
import showFile from "../../helpers/show_file";
import formatHelper from "../../helpers/format_helper";
import { CurrenciesEnum, CourseStatusesEnum } from "../../utils/enums";
import Tooltip from "antd/lib/tooltip";
import { Fragment } from "react";
import { formatAmount } from "../../helpers/format_amount";

const CourseCard = ({ data }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="course_card">
        <div className="course_card_title">
          <span>{data.enrollmentCount} enrolled</span>
          {data?.active == false ? (
            <Tooltip title={`This course has been deactivated by the admin.`}>
              <div
                style={{
                  backgroundColor: "#ff472e",
                  marginRight: 8,
                }}
              >
                Inactive
              </div>
            </Tooltip>
          ) : null}
          <Tooltip
            title={
              data.status == 0
                ? `Reason for rejection : ${data.reasonReject}`
                : null
            }
          >
            <div
              style={{
                backgroundColor: CourseStatusesEnum?.find(
                  (o) => o.value == data.status,
                )?.color,
              }}
            >
              {CourseStatusesEnum?.find((o) => o.value == data.status)?.label}
            </div>
          </Tooltip>
        </div>
        <div className="course_card_banner">
          {data?.banner ? <img src={showFile(data.banner?.name)} /> : null}
        </div>
        <div className="course_card_content">
          <h3>{data.name}</h3>
          <div className="rate_container">
            <div>
              <Rate disabled defaultValue={data?.rating?.toFixed(1)} />{" "}
              <span>{data.rating ? data.rating?.toFixed(1) : 0}/5</span>
            </div>
            <p>{data.reviewCount} reveiws</p>
          </div>
          <div className="course_card_prices">
            {data?.discount && data.free == false ? (
              <div>{data?.discount?.amount}%</div>
            ) : null}
            {data.free == true ? <p>FREE</p> : null}
            {data?.prices?.map((price, index) => (
              <h1
                style={data.free == true ? { filter: "blur(2px)" } : {}}
                key={index}
              >
                {data.discount ? (
                  <Fragment>
                    {
                      CurrenciesEnum.find((o) => o.value == price.currency)
                        ?.label
                    }{" "}
                    {formatAmount(
                      price.price - (price.price / 100) * data.discount?.amount,
                    )}
                  </Fragment>
                ) : (
                  <Fragment>
                    {
                      CurrenciesEnum.find((o) => o.value == price.currency)
                        ?.label
                    }{" "}
                    {formatAmount(price.price)}
                  </Fragment>
                )}

                {data.discount ? (
                  <span>
                    {
                      CurrenciesEnum.find((o) => o.value == price.currency)
                        ?.label
                    }{" "}
                    {formatAmount(price.price)}
                  </span>
                ) : null}
              </h1>
            ))}
          </div>
        </div>
        <div className="course_card_btn">
          <Tooltip
            title={
              data.status == 0
                ? "You cannot edit this course because it has been rejected."
                : null
            }
          >
            <Button
              disabled={data.status == 0}
              style={data.status == 0 ? { opacity: 0.65 } : {}}
              onClick={() => navigate(`/courses/edit/${data.id}`)}
            >
              <span>Edit</span>
            </Button>
          </Tooltip>
          <Tooltip
            title={
              data.status == 0
                ? "You cannot enter the details of this course because it has been rejected."
                : null
            }
          >
            <Button
              onClick={() => {
                navigate(`/courses/view/${data.id}`);
              }}
              style={data.status == 0 ? { opacity: 0.65 } : {}}
              disabled={data.status == 0}
            >
              <span>Preview</span>
            </Button>
          </Tooltip>
        </div>
      </div>
    </>
  );
};

export default CourseCard;
